<template>
  <div>
    <!-- {{ '@/assets/images/'+flag+'.png' }} -->
    <flag v-if="flag.length==2" :iso="code" size="L" :squared="false"/>
    <img class="langIcon" v-if="lenguajesEspeciales.some(l=>l==flag)" :src="'/img/'+flag+'.png'" width="16"/>
    <!-- <img :src="'/img/' + entry?.Flag + '.png'" width="16"  :alt="$t('imagenIdioma')" /> -->
  </div>
</template>
<script>

export default {
  name: "IconoIdioma",
  props: {
    flag:{
      type:String,
      default:""
    }
  },
  data(){
    return {
      lenguajesEspeciales:['eu','ca','en']
    }
  },
  computed:{
    code:{
      get(){
        switch (this.flag.toLowerCase()) {
          case 'eu':
            return ''
          case 'ca':
            return ''
          case 'en':
            return ''
          default:
            return this.flag.toUpperCase()
        
        }
      }
    }
  },
  created(){
    
  },
  methods:{
    
  }
}
</script>
<style>
  .fi{
    border-radius: 50%;
    width: 16px !important;
    line-height: 16px !important;
    background-size: cover !important;
  }
  .langIcon{
    border-radius: 50%;
    width: 16px !important;
    height: 16px !important;
    background-size: cover !important;
  }
</style>